<template>
	<!-- 生成凭证 -->
	<div id='newAddVoucherDialog'>
		<el-dialog
	          title="生成凭证"
	          :visible.sync="isShow"
	          :width="dialogWidth"
	          :close-on-click-modal='false'
	          :close-on-press-escape="false"
	          top="100px"
			  @close="close"
	          class='handleNewAddVoucherDialog'
	          >
	          <div v-loading='loading' element-loading-text="拼命加载中...">
				      <el-empty :image-size="200" v-if="allVoucherList.length==0"></el-empty>
		          <div class='item_container' :style='itemContainer' v-if="allVoucherList&&allVoucherList.length">
		          	
							<div class='per_item' v-for='(items,index) in allVoucherList' :key='index'>
								<div class='per_item_right' :style='{background: items.preVou.debitTotal===items.preVou.creditorTotal?"rgba(38, 157, 123, .04)":"rgba(255,170,0,.1)"}' v-if='isRefreh'>
									<!-- <el-scrollbar class="default-scrollbar"> -->
										<div style='margin-right: 30px;' class='container_r'>
											<div class='header'>
												<div class="vou">
													<div>凭证日期：{{$formart(items.preVou.date,'yyyy-MM-dd')}}</div>
													<div>凭证字号：{{items.preVou.certificateWord}}-{{items.preVou.number}}</div>
												</div>
												<div style='color:#FFAA00;font-size: 12px;' v-if='items.preVou.debitTotal!==items.preVou.creditorTotal'>
													<i class='el-icon-warning'></i>
													借贷不平
												</div>
											
											</div>
											<el-row style='margin-bottom: 10px;'>
												<el-col :span='10'></el-col>
												<el-col :span='10'></el-col>
												<el-col :span='4'>
												</el-col>
											</el-row>
											<PublicTable
											:table="items.preVou.tableData"
											>
											<template slot='debitMoney' slot-scope='props'>
												<span>{{props.scope.row.debitMoney || ''}}</span>
											</template>
											<template slot='creditorMoney' slot-scope='props'>
												<span>{{props.scope.row.creditorMoney || ''}}</span>
											</template>
											</PublicTable>
										
											</div>
											<!-- </el-scrollbar> -->
											<div class='footer'>
												<span @click='editVouchers(items)' style="color:#269D7B;">手动修改</span>
												<span @click='deleleVoucher(items,index)' style="color:#FF6010;">删除</span>
											</div>
								</div>
								<div class='per_item_center'>
									<img src="/static/img/lianjie.png" alt="">
								</div>
								<div class="Invoice_table">
									<div class="header">
										<div style="width:100px">序号</div>
										<div style="width:220px;"> {{type==1 || type ==3?'发票号码':'银行流水'}}</div>
									</div>
									<div class="content">
										<div v-for="(contentItem,contentIndex) in items.billList" :key="contentIndex">
											<div class="content_item">{{contentIndex + 1}}</div>
											<template v-if="type == 1||type == 3">
												<div class="content_item">{{contentItem.invoiceNumber}}</div>
											</template>
											<template v-if="type == 2">
												<div class="content_item">
													<div style="display:flex;justify-content:space-between;">
														<div>{{contentItem.dateStr}}</div>
														<div>{{contentItem.totalAmount}}</div>
													</div>
													<div>{{contentItem.displayContent}}</div>
												</div>
											</template>
										</div>
									</div>
									<div class="footer">
										<div >
											<div class="footer_item">金额</div>
											<div class="footer_item">{{items.totalAmount||0}}</div>
										</div>
										<div v-if="type==1 || type == 3">
											<div class="footer_item">税额</div>
											<div class="footer_item">{{items.totalTax||0}}</div> 
										</div>
										<div v-if="type==1 || type == 3">
											<div class="footer_item">价税合计</div>
											<div class="footer_item">{{totalMoney(items.totalAmount,items.totalTax)}}</div>
										</div>
									</div>

								</div>
							</div>
		          </div>
		          <!-- 底部 -->
		          <div class='dialogFooter'>
		          		<el-button style='width: 122px;background: #F6F8FA;color: #333;border:0;' size='small' @click='isShow=false'>取消</el-button>
		          		<el-button style='width: 122px;background: #269D7B;color: #fff;'  size='small' @click='handleSaveAllVoucher' :disabled="errorLock">保存</el-button>
		          </div>
	          </div>
	    </el-dialog>
      <!-- 手动修改凭证凭证  -->
      <edit-voucher
        :visible="XG_voucherShow"
        :row="Voucher_Chief_Data"
      	@on-close-dialog="cancel($event,'edit')"
        @on-success-submit="successEdit"
      >
      </edit-voucher>
	</div>
</template>
<script>
	import PublicTable from '@/components/publicTable'
	import editVoucher from '@/components/table/editVoucher'
	import {currencys} from '@/assets/utils/currencyFormat'
	export default {
		props:{
			settingType:String,
			newAddVoucherDialogShow:Boolean,
			generateType:String|Number,
			ids:String,
			type:Number,
			saveType:{
				type:String|Number,
				default:1
			},
			voucherTemplateList:Array,
		},
		components:{
			PublicTable,
			editVoucher
		},
		data() {
			return {
			    // tableData: {
				// 	border: true,				// 是否带有纵向边框
				// 	stripe: true,				// 是否带有斑马纹
				// 	loading: false,				// 是否显示加载动画
				// 	hasSelect: true,			// 是否显示多选
				// 	hasOperation: false,		// 是否有操作功能
				// 	hasContextmenu: false,		// 是否有右键功能
				// 	hasShowSummary: true,		// 是否显示合计行
				// 	hasShowPagination: false,	// 是否显示分页
				// 	// Maxheight: 600,			// Table最大高度
				// 	config: [
				// 	{
				// 		label: '摘要',
				// 		value: 'invoiceSource',
				// 		show: 'template'
				// 	},
				// 	{
				// 		label: '会计科目',
				// 		value: 'billingDate',
				// 		show: 'normal'
				// 	},
				// 	{
				// 		label: '贷方金额',
				// 		value: 'invoiceNumber',
				// 		show: 'normal'
				// 	}, {
				// 		label: '借方金额',
				// 		value: 'enterprieName',
				// 		width: 150,
				// 		show: 'normal'
				// 	},],
				// 	data: [],
				// 	center: {
				// 	textAlign: 'center',
				// 	padding: '6px 0'
				// 	},
				// 	getSummaries: this.getSummaries,			// 自定义合计方法
     			// },
				errorLock:false,
				dialogWidth:"1200px",
				superDataId:"",
				itemContainer:{height:''},
				isRefreh:true,
				Voucher_Chief_Data:{},
				XG_voucherShow:false,   // 手动修改
				loading: false,
				allVoucherList:[],     // 所有凭证集合
				form:{
					invoiceVoucherTemplateId:"",
				}
			}
		},
		created() {

		},
		computed:{

			// 显示弹窗
			isShow: {
				get () {
					return this.newAddVoucherDialogShow;
				},
				set (val) {
					this.$emit('update:newAddVoucherDialogShow', val);
				}
			},
		},
		methods:{
			getSummaries(param){
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0 ) {
						sums[index] = '合计';
						return;
					}
					if (index === 2 || index ===3) {
					const values = data.map(item => {
						return Number(item[column.property])
					});

					if (!values.every(value => { isNaN(value) })) {
						sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							prev = Number(prev)
							if (!(parseFloat(prev) + parseFloat(curr))) {
							return '';
							} else {
							return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
							}
						} else {
							return parseFloat(prev).toFixed(2);
						}
						}, 0);
					} else {
						sums[index] = '';
					}

					}else {
					return
					}

				});
				if (sums) {
					return sums;
				} else {
					return '';
				}
			},
			totalMoney(val,val2){
				return (Number(val) + Number(val2)).toFixed(2)||0
			},
			close(){
				// this.dialogWidth = '1256px'
			},
			// 格式化钱钱
			formatMoney(val) {
				val=val?Number(val):0;
				val = val.toFixed(2);
				return currencys(val);
			},
			// 模板保存上一次
			handleChangeSelects(e,row) {
				// superDataId
				if(e) {
					this.superDataId = row.invoice.invoiceVoucherTemplateId;
				}
			},
			// 模板凭证改变事件
			handleChangeSelect(e,row,index) {
				this.loading = true;
				let params={
					invoiceId:row.invoice.id,
					temId:e,
					num:row.preVou.number,
				}
				this.$http.post('PreVoucherChiefController/updTemPreview' ,params).then(res=>{
					this.loading = false;
					if(res&&res.data.code==1){
						let editRow = res.data.data[0].preVou;
						this.allVoucherList.forEach((i,indexs)=>{
							if(index === indexs) {
								i.preVou = editRow;
							}
						});
						this.$message.success('修改成功！')
						this.$emit('refreshTable',true);
					}else {
						row.invoice.invoiceVoucherTemplateId = this.superDataId;
					}
				})
			},
			// 修改成功回调
			successEdit(data) {
        console.log(data,"修改数据");
				this.allVoucherList.forEach((i,index)=>{
					if(i.isEdit) {
						i.preVou.date = data.data.date;
						i.preVou.number = data.data.selfNumber;
						i.preVou.voucherAddendumVoList = data.data.voucherAddendumVoList;
						i.preVou.tableData.data = data.data.voucherAddendumVoList
						i.preVou.preVoucherAddendumList = data.data.voucherAddendumVoList;
						i.preVou.creditorTotal = data.total.c_money?data.total.c_money.toFixed(2):0;
						i.preVou.debitTotal =  data.total.d_money?data.total.d_money.toFixed(2):0;
						i.preVou.fkVoucherWordId = data.data.fkVoucherWordId?data.data.fkVoucherWordId:i.preVou.fkVoucherWordId;
						i.preVou.fkVoucherWord = data.data.certificateWord?data.data.certificateWord:i.preVou.fkVoucherWord;
					}
					return i;
				});
				this.XG_voucherShow = false;

			},
			// 修改关闭
			cancel(e,type) {
				this.XG_voucherShow = false;
			},
			// 修改凭证
			editVouchers(row) {
				console.log(row)
				//this.Voucher_Chief_Data =row.preVou.preVoucherAddendumList;
				this.Voucher_Chief_Data =row.preVou;
				this.XG_voucherShow = true;
				this.allVoucherList.map(i=>{
					i.isEdit = false;
					return i;
				});
				row.isEdit = true;
			},
			// 删除凭证
			deleleVoucher(row,index) {
				if(this.allVoucherList.length===1) {
					this.isShow = false;
				}else {
					this.allVoucherList.splice(index,1);
				}
			},
			// 查询所有凭证信息
			getAllVoucherData() {
				this.loading = true;
				this.itemContainer.height = ''
				// //1单个生成 查询   2多个合并生成查询
				// if(this.generateType==1){
				// 	this.$http.post('PreVoucherChiefController/generatePreview' , {invoiceIds:this.ids}).then(res=>{
				// 	this.loading = false;
				// 	if(res&&res.data.code==1){
				// 		this.allVoucherList = res.data.data.map(i=>{
				// 			i.isEdit = false;
				// 			i.preVou.creditorTotal = i.preVou.creditorTotal?i.preVou.creditorTotal.toFixed(2):0;
				// 			i.preVou.debitTotal = i.preVou.debitTotal?i.preVou.debitTotal.toFixed(2):0;
				// 			return i;
				// 		});
				// 		if(this.allVoucherList.length===1) {
				// 			this.itemContainer.height = '350px'
				// 		}else {
				// 			this.itemContainer.height = '638px'
				// 		}
				// 	}else {
				// 		this.allVoucherList = []
				// 	}
				// })
				// }
				// else {
					this.$http.post('PreVoucherChiefController/generatePreviewV2' , {ids:this.ids,type:this.type,combinationMode:this.settingType}).then(res=>{
						this.loading = false;
						if(res&&res.data.code==1){
							this.allVoucherList = res.data.data.map(e=>{
								e.preVou = e.voucherChiefVo
								e.preVou.creditorTotal = e.preVou.creditorTotal?e.preVou.creditorTotal.toFixed(2):0;
								e.preVou.debitTotal = e.preVou.debitTotal?e.preVou.debitTotal.toFixed(2):0;
								e.preVou.tableData = {
									border: true,				// 是否带有纵向边框
									stripe: true,				// 是否带有斑马纹
									loading: false,				// 是否显示加载动画
									hasSelect: false,			// 是否显示多选
									hasOperation: false,		// 是否有操作功能
									hasContextmenu: false,		// 是否有右键功能
									hasShowSummary: true,		// 是否显示合计行
									hasShowPagination: false,	// 是否显示分页
									Maxheight: 300,			// Table最大高度
									config: [
									{
										label: '摘要',
										value: 'summary',
										show: 'normal'
									},
									{
										label: '会计科目',
										value: 'subjectName',
										show: 'normal'
									},
									{
										label: '借方金额',
										value: 'debitMoney',
										show: 'template'
									},
									{
										label: '贷方金额',
										value: 'creditorMoney',
										show: 'template'
									}],
										data: e.preVou.voucherAddendumVoList,
										center: {
										textAlign: 'center',
										padding: '6px 0'
									},
									getSummaries: this.getSummaries,		
								}
								// if(e.billList&&e.billList.length){
								// 	let list = []
								// 	for (let i = 0; i < e.billList.length; i += 10) {
								// 	if(this.type==1 || this.type ==3){
								// 		list.push(e.billList.slice(i, i + 10).map(e=>e.invoiceNumber))
								// 	}else {
								// 		list.push(e.billList.slice(i, i + 10).map(e=>{
								// 			return {
								// 				displayContent:e.displayContent,
								// 				dateStr:e.dateStr,
								// 				totalAmount:e.totalAmount
								// 			}
								// 		}))
								// 	}
								// 	}
								// 	e.totalLength = e.billList.length
								// 	// if(this.dialogWidth!='1600px'&&e.totalLength>=4){
								// 	// 	this.dialogWidth = '1600px'
								// 	// }

								// 	e.newList = list
								// }
								return e
							})
							console.log(this.allVoucherList,'凭证信息')
							this.errorLock = false
							this.countMoney()
						}else {
							this.allVoucherList = []
							this.errorLock = true
						}
					})
				// }
			},
			//计算金额
			countMoney(){
				console.log(this.allVoucherList)
				this.allVoucherList.forEach(e=>{
					if(e.billList&&e.billList.length){
						console.log(e.billList)
						let totalAmount = e.billList.reduce((prev, item) => prev + item.totalAmount, 0);
						let totalTax = e.billList.reduce((prev, item) => prev + item.totalTax, 0);
						e.totalAmount = totalAmount.toFixed(2)
						e.totalTax = totalTax.toFixed(2)
					}
					console.log(e.totalAmount ,e.totalTax)
				})
			},
			// 保存凭证
			handleSaveAllVoucher() {
				if(!this.allVoucherList.length) return
				let list = this.$lodash.cloneDeep(this.allVoucherList)
				//1单个生成 保存  2合并生成 保存
				// if(this.generateType==1) {
				// 	let preVoucherChiefs=[];
				// 	this.loading = true;
				// 	if(list.length) {
				// 		list.forEach(i=>{
				// 			preVoucherChiefs.push(i.preVou);
				// 		})
				// 	}
				// 	this.$http.post('PreVoucherChiefController/savaVoucherChief' , {preVoucherChiefs:preVoucherChiefs}).then(res=>{
				// 		this.loading = false;
				// 		if(res&&res.data.code==1){
				// 			this.isShow = false;
				// 			this.$emit('refreshTable',true);
				// 			this.$message.success(res.data.msg)
				// 		}
				// 	})
				// } else {
				if(list&&list.length){
					list = list.map(e=>{
						e.type = e.type || this.saveType
						delete e.preVou
						delete e.totalLength
						delete e.newList
						delete e.totalAmount
						delete e.totalTax
						delete e.isEdit
						if(e.voucherChiefVo&&e.voucherChiefVo.voucherAddendumVoList&&e.voucherChiefVo.voucherAddendumVoList.length){
							delete e.voucherChiefVo.preVoucherAddendumList
							e.voucherChiefVo.voucherAddendumVoList = e.voucherChiefVo.voucherAddendumVoList.map(el=>{
								delete el.subjectVo.select
								delete el.subjectVo.subjectNames
								delete el.isFapiaoData
								delete el.isFlowBtnShow
								delete el.subjectNames
								return el
							})

						}
						return e
					})
				}
				this.$http.post('PreVoucherChiefController/savaVoucherChiefV2' , list,{json:true}).then(res=>{
					this.loading = false;
					if(res&&res.data.code==1){
						this.isShow = false;
						this.$emit('refreshTable',true);
						this.$message.success(res.data.msg)
					}
				})
				// }
			},
		},
		watch: {
			newAddVoucherDialogShow(val){
				if(val) {
					this.getAllVoucherData();
				}
			}
		}
	}
</script>
<style lang='less'>
	.Invoice_table {
		.header {
			display: flex;
			align-items: center;
			border: 1px solid #e9e9e9;
			&>div:first-child {
			border-right: 1px solid #e9e9e9;
			}
			&>div {
				padding: 10px;
				color: #333333;
				font-weight: bold;
				background: rgba(247, 247, 247, .5);
				box-sizing: border-box;
			}
		}
		.content {
			&>div {
				display: flex;
				align-items: stretch;
				border: 1px solid #e9e9e9;
				border-top: 0 !important;
				.content_item {
					&:first-child {
						border-right: 1px solid #e9e9e9;
						width: 100px;
					}
					&:last-child {
						width: 220px;
					}
					padding: 10px;
					color: #666666;
					// font-weight: bold;
					background: #fff;
					box-sizing: border-box;
				}
		}
		}
		.footer {
			&>div {
				display: flex;
				align-items: center;
				border: 1px solid #e9e9e9;
				border-top: 0 !important;
				.footer_item {
					&:first-child {
						border-right: 1px solid #e9e9e9;
						width: 100px;
					}
					&:last-child {
						width: 220px;
					}
					padding: 10px;
					color: #333333;
					font-weight: bold;
					background: rgba(247, 247, 247, .5);
					box-sizing: border-box;
				}
			}
		}
	// 	display: flex;
	// 	align-items: center;
	// 	flex-direction: column;
	// 	row-gap: 20px;
	// 	.Invoice_money {
	// 	font-size: 18px;
	// 	font-weight: bold;
	// 	column-gap: 20px;
	// 	display: flex;
	// 	align-items: center;
	// }
	}

	#newAddVoucherDialog {
		.billList_table {
			.table_header {
				border: 1px solid #EBEEF5;
				display: flex;
				align-items: center;
				div {
					width: 100px;
					height: 32px;
					line-height: 32px;
					text-align: center;
				}
			}
		}
		.default-scrollbar {
			width: 100%;
			height: 100%;
		}
		.el-scrollbar__wrap,.default-scrollbar__wrap {
		  overflow-x: hidden;
		}
		.handleNewAddVoucherDialog {
			.el-dialog__header {
				// text-align: center;
				// padding: 30px 0;

				// border-bottom: none;
				.el-dialog__title {
					color:#333333;
					// font-size: 30px;
					font-weight: bold;
				}

			}
			.el-dialog__body {
				padding: 0 30px 50px 30px;
			}
			.item_container {
				overflow: hidden;
				.per_item {
					display: flex;
					// justify-content: space-between;
					margin-bottom: 30px;
					align-items: center;
					column-gap: 20px;
					.per_item_left,.per_item_right {
						width: 748px;
            height: 260px;
						border-radius: 5px;
					}
					.per_item_left {
            background-color: #FBFBFB;
						padding: 20px;
						box-sizing: border-box;
            &__row {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
						.per_item_left_title {
							color: #4A4A4A;
							font-size: 18px;
							text-align: center;
						}
						.fp_number {
							color:#666666;
							font-size: 14px;
							text-align: right;
							margin: 10px 0 15px 0;
						}
						.detail_table {
							width: 100%;
							border-collapse: collapse;
							border-spacing: 0;
							td {
								border:1px solid #E7E7E7
							}
							.table_row {
								td {
									padding:13px 0 15px;
									width: 25%;
									span {
										display: block;
										&:last-child{
											margin-top:10px;
										};
									}
								}
							}
						}
					}
					.per_item_right {
						position: relative;
						padding: 20px 24px;
						box-sizing:border-box;

						.hiddenText {
							 white-space: nowrap;
							 overflow: hidden;
							text-overflow:ellipsis;
						}
						.header {
							display: flex;
							justify-content: space-between;
							align-items: center;
							.vou {
								display: flex;
								align-items: center;
								column-gap: 24px;
							}
							// margin-bottom: 20px;
							// .title {
							// 	color: #4A4A4A;
							// 	font-size: 18px;
							// 	font-weight: 600;
							// }
						}
						.total {

						}
						.container_r {

						}
						.footer {
							text-align: right;
							position: absolute;
							box-sizing: border-box;
							bottom: 0;
							left:0;
							padding: 14px 20px;
							width: 100%;
							text-align: right;
							background-color: rgba(0,0,0,.1);
							display: none;
							user-select: none;
							z-index:999;
							span {
								cursor: pointer;
								&:first-child{
									color:#268AFF;
									margin-right: 20px;
								}
								&:hover {
									opacity:.8;
								};
							}
						}
						&:hover{
							.footer {
								display: block;
							}
						};
					}
					.per_item_center {
						line-height: 304px;
					}
				}

			}
			.dialogFooter {
				text-align: right;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/newAddVoucherDialog.vue